class PressedPassword {
  constructor(element) {
    this.element = element;
    this.countdown = element.querySelector('[data-pressed-countdown]');
    this.cursor = element.querySelector('[data-pressed-cursor]');

    this.initCountdown();
    this.initCursor();
  }

  initCountdown() {
    if (!this.countdown) return;

    const launchTime = Date.parse(this.countdown.dataset.launchDate);
    if (Number.isNaN(launchTime)) {
      this.showExpired(this.countdown.dataset.expiredMessage);
      return;
    }

    const update = () => {
      const remaining = launchTime - Date.now();
      if (remaining <= 0) {
        this.showExpired(this.countdown.dataset.expiredMessage);
        window.clearInterval(this.countdownTimer);
        return;
      }

      const days = Math.floor(remaining / 86400000);
      const hours = Math.floor((remaining % 86400000) / 3600000);
      const minutes = Math.floor((remaining % 3600000) / 60000);
      const seconds = Math.floor((remaining % 60000) / 1000);

      this.setValue('[data-days]', days);
      this.setValue('[data-hours]', hours);
      this.setValue('[data-minutes]', minutes);
      this.setValue('[data-seconds]', seconds);

      const status = this.countdown.querySelector('[data-countdown-status]');
      if (status && seconds === 0) status.textContent = `${days} days, ${hours} hours and ${minutes} minutes until launch.`;
    };

    update();
    this.countdownTimer = window.setInterval(update, 1000);
  }

  setValue(selector, value) {
    const node = this.countdown.querySelector(selector);
    if (node) node.textContent = String(value).padStart(2, '0');
  }

  showExpired(message) {
    this.countdown.innerHTML = `<p class="pressed-password__launching">${this.escapeHtml(message)}</p>`;
  }

  initCursor() {
    if (!this.cursor || !window.matchMedia('(pointer: fine) and (prefers-reduced-motion: no-preference)').matches) return;

    this.element.addEventListener('pointermove', (event) => {
      this.cursor.style.left = `${event.clientX}px`;
      this.cursor.style.top = `${event.clientY}px`;
      this.cursor.classList.add('is-visible');
    });

    this.element.addEventListener('pointerleave', () => this.cursor.classList.remove('is-visible'));
  }

  escapeHtml(value) {
    const element = document.createElement('div');
    element.textContent = value || '';
    return element.innerHTML;
  }
}

document.querySelectorAll('[data-pressed-password]').forEach((element) => new PressedPassword(element));
